import type { JSX } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useCustomTranslation } from "@plansoft-configuration-renderer/localization";

import { CustomButtonUiProps } from "./ButtonUiProps";

export function CustomButtonUi(props: CustomButtonUiProps): JSX.Element {
  const {
    buttonFullWidth,
    buttonColor,
    buttonText,
    buttonVariant,
    wrapperSxProps,
    onClick,
    icon: Icon,
    disabled,
    hybridMode,
    iconPosition,
  } = props;

  const { t } = useCustomTranslation();

  if (Icon && !hybridMode) {
    return (
      <Box sx={wrapperSxProps}>
        <Button
          sx={{
            width: "100%",
          }}
          color={buttonColor}
          variant={buttonVariant}
          onClick={onClick}
          disabled={disabled}
        >
          <Icon />
        </Button>
      </Box>
    );
  }

  if (Icon && hybridMode) {
    return (
      <Box sx={wrapperSxProps}>
        <Button
          startIcon={iconPosition === "start" ? <Icon /> : undefined}
          endIcon={iconPosition === "end" ? <Icon /> : undefined}
          color={buttonColor}
          variant={buttonVariant}
          onClick={onClick}
          fullWidth={buttonFullWidth}
          disabled={disabled}
        >
          {t(buttonText)}
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={wrapperSxProps}>
      <Button
        color={buttonColor}
        variant={buttonVariant}
        onClick={onClick}
        fullWidth={buttonFullWidth}
        disabled={disabled}
      >
        {t(buttonText)}
      </Button>
    </Box>
  );
}
